import { LiksButton } from '../../../components/liks/LiksButton/LiksButton';
import { LiksDialog } from '../../../components/liks/LiksDialog/LiksDialog';
import { useTenantCostSettingsQuery } from '../../tenant/queries/useTenantCostSettingsQuery';
import { useI18n } from '../../../i18n/useI18n';
import './CostPricesDialog.css';

function formatTokenPrice(
  value: number | null | undefined,
  locale: string,
): string {
  if (value == null || !Number.isFinite(value)) return '–';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(value);
}

export function CostPricesDialog({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { locale, translate } = useI18n();
  const costSettingsQuery = useTenantCostSettingsQuery(isOpen);
  const data = costSettingsQuery.data;

  const rows = data
    ? [
        {
          label: translate('organisationManagement.costs.prices.llmInput'),
          value: formatTokenPrice(data.llmInputPrice, locale),
        },
        {
          label: translate('organisationManagement.costs.prices.llmOutput'),
          value: formatTokenPrice(data.llmOutputPrice, locale),
        },
        {
          label: translate(
            'organisationManagement.costs.prices.embeddingInput',
          ),
          value: formatTokenPrice(data.embeddingInputPrice, locale),
        },
        {
          label: translate('organisationManagement.costs.prices.imageInput'),
          value: formatTokenPrice(data.imageInputPrice, locale),
        },
        {
          label: translate('organisationManagement.costs.prices.imageOutput'),
          value: formatTokenPrice(data.imageOutputPrice, locale),
        },
      ]
    : [];

  return (
    <LiksDialog
      isOpen={isOpen}
      size="sm"
      title={translate('organisationManagement.costs.prices.title')}
      onClose={onClose}
      footer={
        <LiksButton variant="secondary" onClick={onClose}>
          {translate('organisationManagement.costs.prices.close')}
        </LiksButton>
      }
    >
      {costSettingsQuery.isLoading ? (
        <p className="tenant-prices-dialog__status">
          {translate('organisationManagement.costs.loading')}
        </p>
      ) : costSettingsQuery.isError ? (
        <p className="tenant-prices-dialog__status" role="alert">
          {translate('organisationManagement.costs.loadError')}
        </p>
      ) : (
        <dl className="tenant-prices-dialog__list">
          {rows.map((row) => (
            <div key={row.label} className="tenant-prices-dialog__row">
              <dt>{row.label}</dt>
              <dd>{row.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </LiksDialog>
  );
}
